import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import {getFileXlsx} from "../templates/CostUpload/FileReceiver";

export const downloadErrorReport = async (fileId, fileName,downloadFile) => {
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }

    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.errorReportFile}${fileId}/${downloadFile}`;

    const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
            Authorization: 'Bearer ' + tokenInfo.id_token,
            Principal: tokenInfo.access_token,
        },
    });

    if (response.ok) {
        await getFileXlsx(fileName, response,downloadFile);
    } else {
        console.error("Error while downloading the report:", response.statusText);
    }
};
